import { HttpPromise } from "@shared/svelte/Modules/ApiService";
import type { RetailerFulfillmentMethod } from "@shared/types/RetailerFulfillmentMethod";
import { OHLQ_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

export async function getDistributorFulfillmentMethod(
  distributorId: number,
): Promise<RetailerFulfillmentMethod> {
  try {
    return await HttpPromise({
      url: `/api/retailer/retailer_fulfillment_methods/${distributorId}`,
      method: "GET",
    });
  } catch (e) {
    return e;
  }
}

export async function getSavedFulfillmentMethods(): Promise<RetailerFulfillmentMethod[]> {
  try {
    return await HttpPromise({
      url: "/api/retailer/retailer_fulfillment_methods",
      method: "GET",
    });
  } catch (e) {
    return e;
  }
}

export async function updateFulfillmentMethod(
  distributorId: number,
  stockSiteId: string,
): Promise<RetailerFulfillmentMethod> {
  try {
    return await HttpPromise({
      url: `/api/retailer/retailer_fulfillment_methods/${distributorId}`,
      method: "PUT",
      data: {
        warehouse_location_code: stockSiteId,
      },
    });
  } catch (e) {
    return e;
  }
}

export function shouldUseRetailerFulfillmentMethodForDistributor(
  distributor_id: number,
  usesWarehousePickup: boolean,
  usesWineCellar: boolean,
): boolean {
  return distributor_id && usesWarehousePickup && usesWineCellar;
}

export const hideFulfillmentMethodPickerForDistributor = (distributor_id: number): boolean =>
  distributor_id === OHLQ_DISTRIBUTOR_ID;
